import styled, { css } from 'styled-components';
import { Text } from '~/components/ui/Text';
import shadow from '../../assets/images/promocode/promocode_item_shadow.png';

const StyledContainer = styled.div<{ $rowSpan?: number; $colSpan?: number }>`
	position: relative;
	grid-row: span ${(props) => props.$rowSpan};
	grid-column: span ${(props) => props.$colSpan};
	overflow: hidden;
	border-radius: 5px;
`;

const StyledItemContainer = styled.div<{ $bigImage?: boolean }>`
	position: relative;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	height: 100%;
	background: rgba(255, 255, 255, 0.02);
	border: 1px solid rgba(255, 255, 255, 0.05);
	border-radius: 5px;

	img {
		object-fit: contain;
		user-select: none;
		pointer-events: none;

		${(props) =>
			props.$bigImage &&
			css`
				width: 100px !important;
				height: 100px !important;
			`}
	}
`;

const StyledShadow = styled.div`
	position: absolute;
	bottom: -75px;
	right: -75px;
	width: 150px;
	height: 150px;
	background-image: url(${shadow});
	background-repeat: no-repeat;
	background-position: center;
	background-size: contain;
`;

const StyledHintContainer = styled.div`
	position: absolute;
	top: -60px;
	left: 50%;
	transform: translateX(-50%);
	display: flex;
	align-items: center;
	gap: 5px;
	height: 40px;
	padding: 0 10px;
	background-color: rgba(255, 255, 255, 0.9);
	border-radius: 10px;
	opacity: 0;
	transition: opacity 0.3s ease;

	${Text} {
		font-weight: 400;
		font-size: 14px;
		color: #000000;
		white-space: nowrap;
	}

	img {
		width: 14px;
		height: 14px;
		object-fit: contain;
		filter: invert(100%);
	}

	&.hint-enter {
		opacity: 0;
	}

	&.hint-enter-active,
	&.hint-enter-done,
	&.hint-exit {
		opacity: 1;
	}

	&.hint-exit-active {
		opacity: 0;
	}
`;

export {
	StyledContainer,
	StyledHintContainer,
	StyledItemContainer,
	StyledShadow,
};
